import { Store } from '@/Core/Models/Stores'
import { Component, MapGetter, Vue } from 'types-vue'
import { Version } from '../../models'

@Component
export default class Timeline extends Vue {
  @MapGetter(Store.Versions) protected versionList: Version[]
}